"use client";

import { useMediaQuery } from "@kyan/ui";

import { BuySellSwitch } from "#/components/BuySellSwitch/BuySellSwitch";
import { InstrumentTag } from "#/components/InstrumentTag/InstrumentTag";
import { useShowTradePanel } from "#/store/app/tradePanel/showTradePanel";
import { useOption } from "#/store/options/tradePanel/option";
import { type TradeDirection } from "#/types/trade";
import { createOptionInstrumentName } from "#/utils/instrument.utils";

export const OptionSummary: React.FC = () => {
  const { isSm } = useMediaQuery();
  const { setShowTradePanel } = useShowTradePanel();
  const { option, bestBid, bestAsk, setOption } = useOption();

  const isBuy = option?.isBuy ?? true;
  const bestPrice = isBuy ? bestAsk : bestBid;

  const handleToggleBuySell = (id: string) => {
    if (option) {
      const isIdBuy = id === "buy";

      setOption({
        ...option,
        isBuy: isIdBuy,
        direction: id as TradeDirection,
      });
    }
  };

  const handleRemoveOption = () => {
    setOption(undefined);
    setTimeout(() => {
      setShowTradePanel(false);
    }, 350);
  };

  if (!option) return null;

  return (
    <div className="w-full">
      <BuySellSwitch isBuy={isBuy} onChange={handleToggleBuySell} />
      <InstrumentTag
        isBuy={isBuy}
        className="my-2"
        price={bestPrice}
        instrumentName={createOptionInstrumentName(option)}
        onRemove={isSm ? handleRemoveOption : undefined}
      />
    </div>
  );
};
